module.exports = "https://www.gc-qa.gnp.com.mx/b7a095b67b4d6d972c130eb788d92095.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/circle-poliza-danios.svg
// module id = 8084
// module chunks = 0